import { RankmiTable } from '@rankmi/rankmi-table'

import type { IRankmiTable } from '@rankmi/rankmi-table/dist/interfaces/tableProps'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { generateTableLocale } from 'helpers/translations.helper'

const prefix = 'configuration.segments.list'

const TableSegments = (props: IRankmiTable) => {
  const { t } = useTranslation()

  const translations = useMemo(
    () =>
      generateTableLocale({
        header: {
          rowsCount_plural: t(`${prefix}.rowsCount_plural`),
          rowsCount: t(`${prefix}.rowsCount`),
        },
      }),
    [t]
  )

  return <RankmiTable {...props} locale={props?.locale || translations} />
}

export default TableSegments
